/**
 * Достаёт тело успешного ответа из конверта сгенерированного клиента.
 *
 * orval описывает ответ как объединение «успех | ошибка», хотя `apiFetch`
 * ошибки выбрасывает и до этой точки они не доходят. Типам об этом не
 * рассказать, поэтому сужение делается здесь один раз, а не в каждом экране:
 * `select: unwrap` в опциях запроса — и `data` уже нужного типа.
 */
export function unwrap<T extends { status: number; data: unknown }>(
  response: T,
): Extract<T, { status: 200 | 201 }>['data'] {
  if (response.status !== 200 && response.status !== 201) {
    // Сюда попасть нельзя: apiFetch выбрасывает на любом не-2xx. Если всё же
    // попали — это ошибка в клиенте, и молчать о ней нельзя.
    throw new Error(`Неожиданный статус успешного ответа: ${String(response.status)}`);
  }

  return response.data;
}
